/** 插件 Drawer 内容，由统一的命令式 Sheet 负责外壳和生命周期。 */
import type { SheetComponentProps } from "@/shared/components/sheet";
import { SheetHeader, SheetTitle } from "@/shared/ui/sheet";

import { PluginIframe } from "./plugin-iframe";

interface PluginDrawerProps extends SheetComponentProps {
  pluginId: string;
  src: string;
  title: string;
}

export function PluginDrawer({
  pluginId,
  src,
  title,
}: PluginDrawerProps) {
  return (
    <>
      <SheetHeader className="px-4 pt-4 pb-2">
        <SheetTitle>{title}</SheetTitle>
      </SheetHeader>
      <div className="flex-1 overflow-hidden bg-background">
        <PluginIframe pluginId={pluginId} src={src} className="block" />
      </div>
    </>
  );
}
